appHost.actions.register({
    // #region Vars
    name: '288a.system.window.open',
    // #endregion
    // #region Entry
    async execute(data, params) {
        let tAddress = params?.address ?? params?.url;
        {
            if (!tAddress) {
                return { isSucceeded: false };
            }
        }
        //Run
        this.$appHost.router.openWindow(tAddress);
        //Finish
        return { isSucceeded: true };
    },
    // #endregion
});
export {};
